import { ReactElement } from 'react';
import { useNavigate } from 'react-router';
import { ArtificialIntelligenceIcon } from '@twilio-paste/icons/esm/ArtificialIntelligenceIcon';
import { Button } from '@twilio-paste/core/button';
import { Text } from '@twilio-paste/core/text';
import { useExperiment, useSegment, useUserDetails } from '../../../hooks';
import {
  routes,
  trackingDetails,
  WISE_OWL_FEATURE_FLAG,
} from '../../../definitions/constants';
import { copy } from '../definitions';

const AiNavButton = (): ReactElement => {
  const navigate = useNavigate();
  const { user } = useUserDetails();
  const { trackEvent } = useSegment();
  const { isOn: shouldRenderWiseOwl } = useExperiment({
    experimentName: WISE_OWL_FEATURE_FLAG,
  });

  const handleTrackingEvent = (): void => {
    trackEvent(trackingDetails.aiNavButtonClicked, {
      user: user?.sid,
    });
  };

  const handleOnClick = (): void => {
    navigate(routes.home);
    handleTrackingEvent();
  };

  /**TODO: Remove shouldRenderWiseOwl check once we go GA */
  if (!shouldRenderWiseOwl) {
    return <div />;
  }

  return (
    <Button variant="reset" onClick={handleOnClick}>
      <ArtificialIntelligenceIcon decorative title="AI icon" />
      <Text as="span" color="colorTextIcon" fontSize="fontSize30">
        {copy.topbar.aiNavButton}
      </Text>
    </Button>
  );
};

export default AiNavButton;
